import React from "react";
import { useTranslation } from "react-i18next";

type InlineErrorWithContactProps = {
  show: boolean;
  onContact: (e: React.MouseEvent) => void;
  messageKey?: string;
  ariaLabel?: string;
};

export default function InlineErrorWithContact({
  show,
  onContact,
  messageKey = "account number is not valid",
  ariaLabel = "Bank account contact cs",
}: InlineErrorWithContactProps) {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <p className="text-right text-xs leading-4 text-error-base transition-[max-height]">
      {t(messageKey)}{" "}
      <button
        onClick={onContact}
        className="cursor-pointer underline"
        aria-label={ariaLabel}
      >
        {t("contact cs")}
      </button>
    </p>
  );
}
